import { Api } from './Api'

const pushSubscriptionsPathTo = {
  vapid: () => {
    return Api.request({
      url: '/push_subscriptions/vapid.json',
      method: 'get'
    })
  },
  create: (data) => {
    return Api.request({
      url: '/push_subscriptions.json',
      method: 'post',
      data
    })
  },
  destroy: (data) => {
    return Api.request({
      url: '/push_subscriptions.json',
      method: 'delete',
      params: { endpoint: data.endpoint },
      data
    })
  }
}

export default pushSubscriptionsPathTo
